<script>
  import { format } from 'svelte-i18n';
  import { Input, Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { sanitizeRulenameOnKeyUp } from '@client/utils/sanitize';

  export let rulename = '';
  export let url = '';
  export let invalidRulename = false;
  export let uploadError = false;
  export let validationError = false;
  export let errorMessage = '';
  export let currentRulenames = [];
  export let onValidation = () => {};
</script>

<div class="video-upload-form">
  <div class="section">
    <div class="heading">
      {$format('label.NAME')} <Icon name="help-circle" id="rulename-info" class="cursor-help h5" />
    </div>
    <Tooltip target="rulename-info" placement="top">{$format('label.TOOLTIP.ASSET_VIDEO_RULENAME')}</Tooltip>
    <Input
      type="text"
      class="rulename"
      placeholder={$format('label.PLACEHOLDER.INPUT', {
        values: { param: $format('label.NAME').toLowerCase() }
      })}
      invalid={invalidRulename}
      feedback={$format('label.VALIDATION_NAME_EXISTS', {
        values: { type: $format('label.VIDEO'), param: $format('label.NAME').toLowerCase() }
      })}
      on:keyup={() => (rulename = sanitizeRulenameOnKeyUp(rulename))}
      bind:value={rulename}
    />
  </div>
  <div class="section">
    <div class="heading">
      {$format('label.VIDEO_DETAILS')}
    </div>
    <div class="asset-details">
      <div class="asset-item">
        <div class="asset-info">
          <b>{$format('label.URL')}</b>
          <p>{$format('label.DESCRIPTION.ASSET_VIDEO_URL')}</p>
        </div>
        <div class="asset-actions">
          <div class="url">
            <Input
              type="url"
              bind:value={url}
              invalid={uploadError || validationError}
              feedback={errorMessage}
              placeholder={$format('label.PLACEHOLDER.ASSET_VIDEO_URL')}
              on:change={() => (uploadError = false)}
              on:blur={onValidation}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .video-upload-form {
    width: 100%;

    .section {
      &:first-child {
        margin-top: var(--margin-base);
      }

      + .section {
        margin-top: var(--margin-xlarge);
      }

      .heading {
        font-size: var(--font-size-large);
        font-weight: var(--font-weight-medium);
        margin-bottom: var(--margin-base);
      }
    }

    .asset-details {
      border: 1px solid var(--border-color);
      border-radius: var(--border-radius-base);
      padding: var(--padding-small) var(--padding-base);

      .asset-item {
        display: flex;
        padding: var(--padding-large);

        .asset-info {
          align-items: center;
          flex: 1;

          b {
            color: var(--color-gray-900);
          }
        }

        .asset-actions {
          align-items: center;
          display: flex;
          justify-content: flex-end;
          gap: 10px;

          .url {
            width: 300px;
          }
        }
      }
    }

    :global(.invalid-feedback) {
      color: var(--color-red-500);
      font-size: var(--font-size-medium);
      margin-top: var(--margin-base);
    }
  }

  @media only screen and (max-width: 800px) {
    .video-upload-form {
      .asset-details {
        .asset-item {
          display: flex;
          flex-direction: column;
          gap: 16px;

          .asset-actions {
            justify-content: flex-start;
          }
        }
      }
    }
  }
</style>
